"use strict";

module.exports.capitalize = function (string) {
  let str = String(string || '');
  return str.slice(0, 1).toUpperCase() + str.slice(1);
};
module.exports.getSpacedPhoneNumber = function (phone_number) {
  let returned_str = '';
  phone_number = String(phone_number || '');
  phone_number = phone_number.split(' ').join('');
  if (phone_number.indexOf('+33') === 0) {
    phone_number = phone_number.substring(3);
    phone_number = '0' + phone_number;
  } else if (phone_number.indexOf('33') === 0) {
    phone_number = phone_number.substring(2);
    phone_number = '0' + phone_number;
  }
  for (let i = 0; i < phone_number.length; i++) {
    if (i > 0 && i % 2 === 0) {
      returned_str += ' ';
    }
    returned_str += phone_number[i];
  }
  return returned_str;
};

/**
 * @version 1.0.1
 * 
 * @param { String } text
 * @param { String } max_length longueur max
 * @param { String } suspension_points points de suspension
 *
 * @returns { String }
**/
module.exports.getTruncatedText = function (text, max_length, suspension_points) {
  if (typeof text !== 'string') return '';
  if (text.length < max_length) return text;
  let short = (text.includes('.') ? text.slice(0, text.lastIndexOf('.')) : text).slice(0, max_length);
  if (suspension_points && short.length < text.length) {
    short = short.split('.').join('. ').split('.  ').join('. ');
    short = short.slice(0, short.lastIndexOf(' ')).trim();
    short += '...';
    short = short.replace('....', '...').trim();
  }
  return short;
};
module.exports.isTrue = val => [true, 'true'].includes(val);
module.exports.isFalse = val => [true, 'true'].includes(val);
